import { createRoot } from "react-dom/client";
import Bailey from "../bailey_v2_10_1.jsx";

createRoot(document.getElementById("root")).render(<Bailey />);
